import {
	inlineEditStatusInteraction,
	inlineEditAssigneeInteraction,
	inlineEditStoryPointInteraction,
	inlineEditOriginalEstimateInteraction,
} from '../utils/performance-analytics';

// Inline Edit Status
export const setInlineEditStatusInteractionStartMark = () => {
	inlineEditStatusInteraction.start();
};

export const setInlineEditStatusInteractionStopMark = (isCompanyManaged: boolean) => {
	inlineEditStatusInteraction.stop({ customData: { isCompanyManaged } });
};

export const cancelInlineEditStatusInteractionMark = () => {
	inlineEditStatusInteraction.cancel();
};

// Inline Edit Assignee
export const setInlineEditAssigneeInteractionStartMark = () => {
	inlineEditAssigneeInteraction.start();
};

export const setInlineEditAssigneeInteractionStopMark = (isCompanyManaged: boolean) => {
	inlineEditAssigneeInteraction.stop({ customData: { isCompanyManaged } });
};

export const cancelInlineEditAssigneeInteractionMark = () => {
	inlineEditAssigneeInteraction.cancel();
};

// Inline Edit Story Point
export const setInlineEditStoryPointInteractionStartMark = () => {
	inlineEditStoryPointInteraction.start();
};

export const setInlineEditStoryPointInteractionStopMark = (isCompanyManaged: boolean) => {
	inlineEditStoryPointInteraction.stop({ customData: { isCompanyManaged } });
};

export const cancelInlineEditStoryPointInteractionMark = () => {
	inlineEditStoryPointInteraction.cancel();
};

// Inline Edit Original Estimate
export const setInlineEditOriginalEstimateInteractionStartMark = () => {
	inlineEditOriginalEstimateInteraction.start();
};

export const setInlineEditOriginalEstimateInteractionStopMark = (isCompanyManaged: boolean) => {
	inlineEditOriginalEstimateInteraction.stop({ customData: { isCompanyManaged } });
};

export const cancelInlineEditOriginalEstimateInteractionMark = () => {
	inlineEditOriginalEstimateInteraction.cancel();
};
